import {isNil} from 'ramda';

import {WORKTREE_QUERY_PARAM} from '../constants/WORKTREE_QUERY_PARAM';
import {setWorktreeOverride} from './setWorktreeOverride';

const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';

/**
 * Local-dev only: picks up `?x-worktree=<name>` from the URL and points the app at that backend
 * worktree. An empty value (`?x-worktree=`) clears the override and goes back to the main backend
 * app. Returns `true` when the target changed, i.e. the caller should redirect to login.
 */
export function applyWorktreeOverrideFromUrl(): boolean {
  if (IS_PRODUCTION_BUILD || typeof window === 'undefined') {
    return false;
  }

  const requestedWorktree = new URLSearchParams(window.location.search).get(WORKTREE_QUERY_PARAM);

  if (isNil(requestedWorktree)) {
    return false;
  }

  return setWorktreeOverride(requestedWorktree === '' ? null : requestedWorktree);
}
